module.exports = __webpack_public_path__ + "img/success.59272b81.png";